import React from 'react';

import { Link } from 'react-router-dom';

import HammerUrl from '@pkg/assets/images/hammer.png';
import { DepButton } from '@pkg/components/deprecated';

import { Typography } from '../DesignSystem';

import { Container, EmojiImage, FormGroup, FormRow, PrimaryCopySection, Section } from './styles';

export function CombineAccounts() {
    // const { setCurrentStep } = useContext(Web3AuthContext);

    return (
        <Container>
            <Section>
                <EmojiImage src={HammerUrl} />
            </Section>
            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    Combine your accounts
                </Typography>
                <Typography type="paragraph" size={18} faded={true}>
                    It looks like you already signed up with this email using a different login method. Confirm your
                    email to combine your accounts.
                </Typography>
            </PrimaryCopySection>
            <Section>
                <FormGroup>
                    <FormRow>
                        <DepButton variant="glow">Resend email</DepButton>
                    </FormRow>
                    <FormRow>
                        <Link to="#different-login">Try a different login method instead</Link>
                    </FormRow>
                </FormGroup>
            </Section>
        </Container>
    );
}
